import React, {useState} from 'react';
import {createPortal} from 'react-dom';
import ModalFormFeedback from '../ModalFormFeedback/ModalFormFeedback';
import {SelectValuesFormSimple} from '../../services/content/Constants';
import {content} from '../../services/content';
import {IContactForms} from '../../redux/initState/InterfacesState';

interface Props {
  text: string;
  buttonClass?: string;
  ariaLabel?: string;
  modalTitle?: string;
  contactForms: IContactForms;
}

/**
 * Кнопка, открывающая модалку обратной связи.
 *
 * Нужна блокам, у которых по макету есть CTA, но нет своей формы (сейчас —
 * калькулятор: в сниппете кнопка вела на несуществующий якорь #lead).
 * Модалка на сайте живёт только в React, поэтому кнопка — маленький остров:
 * PHP отдаёт запасную разметку внутрь контейнера (её видят краулеры и она же
 * остаётся, если бандл не загрузился), React подменяет её на ту же кнопку с
 * обработчиком. Классы контейнера при этом сохраняются — сетку блока держит он.
 */
const ModalFormTrigger = ({text, buttonClass, ariaLabel, modalTitle, contactForms}: Props) => {
  const [showFeedback, setShowFeedback] = useState(false);

  return (
    <>
      <button
        type="button"
        className={buttonClass || 'mk-button mk-button--primary'}
        aria-label={ariaLabel || undefined}
        onClick={() => setShowFeedback(true)}
      >
        {text}
      </button>

      {createPortal(
        <ModalFormFeedback
          hasCssTransition
          showForm={showFeedback}
          id="feedback"
          title={modalTitle || content.header.textModalFeedback}
          select={{options: SelectValuesFormSimple, active: SelectValuesFormSimple[1]}}
          closedModal={() => setShowFeedback(false)}
          contactForms={contactForms}
        />,
        document.body
      )}
    </>
  );
};

export default ModalFormTrigger;
